<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_19_129)">
      <path d="M30 60C13.5 60 0 46.5 0 30C0 13.5 13.5 0 30 0C46.5 0 60 13.5 60 30C60 46.5 46.5 60 30 60ZM30 2.1C14.6 2.1 2.1 14.6 2.1 30C2.1 45.4 14.6 57.9 30 57.9C45.4 57.9 57.9 45.4 57.9 30C57.9 14.6 45.4 2.1 30 2.1Z" fill="#ffffff"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M40 17.4999L12.8 27.9999C12.1 28.2999 12.1 29.1999 12.8 29.4999L19.4 31.9999L22 40.1999C22.2 40.6999 22.8 40.8999 23.2 40.5999L26.9 37.5999C27.3 37.2999 27.8 37.2999 28.2 37.5999L34.9 42.3999C35.4 42.6999 36 42.4999 36.1 41.8999L41 18.3999C41.2 17.7999 40.6 17.2999 40 17.4999ZM34.8 22.9999L24.1 32.9999C23.7 33.2999 23.5 33.7999 23.4 34.2999L23.1 36.9999C23.1 37.3999 22.5 37.3999 22.4 36.9999L21 32.0999C20.8 31.4999 21.1 30.8999 21.6 30.5999L34.6 22.5999C34.8 22.4999 35 22.7999 34.8 22.9999Z" fill="#ffffff"/>
    </g>
    <defs>
      <clipPath id="clip0_19_129">
        <rect width="60" height="60" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>

</script>

<style scoped>

</style>
